import { ListingWithItems } from "@/types";

export const getMonthlySales = (rawData: ListingWithItems[], selectedYear?: number) => {
  const monthlySales = [
    { name: "January", value: 0 },
    { name: "February", value: 0 },
    { name: "March", value: 0 },
    { name: "April", value: 0 },
    { name: "May", value: 0 },
    { name: "June", value: 0 },
    { name: "July", value: 0 },
    { name: "August", value: 0 },
    { name: "September", value: 0 },
    { name: "October", value: 0 },
    { name: "November", value: 0 },
    { name: "December", value: 0 },
  ];

  function getMonthNum(month: string) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return months.indexOf(month);
  }

  function getTotalSalesForMonth(monthNum: number) {
    let totalSales = 0;
    const targetYear = selectedYear || new Date().getFullYear();

    rawData.forEach((listing: ListingWithItems) => {
      if (!listing.listingSoldDate) return;

      const soldDate = new Date(listing.listingSoldDate);
      const soldYear = soldDate.getFullYear();

      if (
        soldYear === targetYear &&
        getMonthNum(
          soldDate.toLocaleString("default", {
            month: "long",
          }),
        ) === monthNum
      ) {
        totalSales +=
          listing.listingSoldPrice -
          listing.listingSoldShipping -
          listing.listingSoldFees;
      }
    });
    return totalSales;
  }

  monthlySales.forEach((_, index: number) => {
    monthlySales[index].value = getTotalSalesForMonth(index);
  });

  return monthlySales;
};
